import type { JSX } from "react";

import {
    IBasket,
    IBasketLine,
    IOptionCode,
    IProduct,
    IWishListLine,
} from "../../../models/catalogue";
import { IProductAPIURL } from "../../../models/nominals";
import { notEmpty } from "../../../utils/functional";

export interface IBasketLineBaseProps<T = IBasketLine | IWishListLine> {
    line: T;
    shippingMethodCode?: string;
}

type TProductUpsell = {
    placement: "in-details" | "post-details";
    hideBottomBorder?: boolean;
    content: JSX.Element;
};

export type TGetProductUpsell = (
    basket: IBasket,
    line: IBasketLine,
    addBasketLine: (
        productURL: IProductAPIURL,
        qty?: number,
    ) => Promise<IBasket>,
) => TProductUpsell | null;

export const listOptions = (
    product: IProduct,
): Array<{
    key: IOptionCode;
    name: string;
    value: string | readonly string[];
}> => {
    const attributes = product.attributes;
    const optionKeys = attributes.product_options?.value || [];
    return optionKeys
        .map((key) => {
            const attr = attributes[key];
            if (!attr) {
                return;
            }
            // TODO(i18n): attr.name and attr.value may contain user-facing strings that should be translated if they come from product attributes
            return {
                key: key,
                name: attr.name,
                value: attr.value,
            };
        })
        .filter(notEmpty);
};
